module.exports = __webpack_public_path__ + "static/media/yo_pani_milyo.fd224591.ogg";